import { createStorageService } from './storage-service'

export const storageService = createStorageService()
